// src/components/PricingPage.js

import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, Link } from 'react-router-dom';
import './PricingPage.css';
import { AuthProvider } from '../AuthContext';
import Footer from './Footer';
import FAQComponent from './unauthComponent/FAQComponent';
import PricingTable from './PricingTable';
import checkmark_icon from '../assets/images/icons/checkmark-icon.png';

const PricingPage = () => {
  const navigate = useNavigate();
  const handleSignUp = () => navigate('/signup');

  // Pricing data & toggle state
  const TIERS = {
    pro: { monthly: 20, yearly: 16, label: '1,000 minutes' }
  };
  const [period, setPeriod] = useState('yearly');
  const price      = TIERS.pro[period];
  const oldMonthly = TIERS.pro.monthly;
  const isYearly   = period === 'yearly';

  const priceLabel = isYearly
    ? (
      <>
        <span className="bp-price-old">${oldMonthly}</span>
        <span className="bp-price-highlight">${price}</span>
        <span className="bp-per-unit">/mo billed annually</span>
      </>
    )
    : (
      <>
        ${price}
        <span className="bp-per-unit">/month</span>
      </>
    );

  return (
    <AuthProvider>
      <Helmet>
        <title>Compare plans, features & costs | Bumpups.com</title>
        <meta
          name="description"
          content="Choose between our free starter plan or upgrade to Pro for 1,000 minutes/month."
        />
      </Helmet>

      <div className="bp-pricing-page">
        <header className="bp-pricing-header">
          <h1>Plans & Pricing</h1>
          <p className="bp-pricing-subtitle">
            Simple, transparent pricing. No surprises.
          </p>

          {/* Monthly / Annual toggle */}
          <div className="bp-period-toggle">
            <button
              className={period === 'yearly' ? 'active' : ''}
              onClick={() => setPeriod('yearly')}
            >
              Annual (Save 20%)
            </button>
            <button
              className={period === 'monthly' ? 'active' : ''}
              onClick={() => setPeriod('monthly')}
            >
              Monthly
            </button>
          </div>
        </header>

        <section className="bp-pricing-tiers">
          {/* Free Plan */}
          <div className="bp-tier">
            <div className="bp-plan-title">
              <div className="bp-plan-title-card">Free</div>
            </div>
            <p className="bp-billing-info">Perfect to get started</p>
            <p className="bp-price">$0 USD</p>
            <button className="bp-cta-button" onClick={handleSignUp}>
              Create an account
            </button>
            <ul className="bp-features-list">
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                <strong>60</strong>{'\u00A0'}processing minutes
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                YouTube processing
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                Chat with your video
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                SEO Tool
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                Prompts workspace
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                Video timestamps
              </li>
            </ul>
          </div>

          {/* Pro Plan */}
          <div className="bp-tier bp-pro">
            <div className="bp-plan-title">
              <div className="bp-plan-title-card">Pro</div>
            </div>
            <p className="bp-billing-info">Best for power users</p>
            <p className="bp-price">
              {priceLabel}
            </p>
            <button className="bp-cta-button bp-pro-button" onClick={handleSignUp}>
              Get started for free
            </button>
            <ul className="bp-features-list">
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                Everything in Free
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                <strong>1,000</strong>{'\u00A0'}processing minutes
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                Local video processing
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                Up to 3h 30m per video
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                16 GB video size
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                Social media scheduler
              </li>
              <li>
                <img src={checkmark_icon} alt="" className="bp-checkmark-icon" />
                Multiple aspect ratios
              </li>
            </ul>
            <p className="bp-footnote">
              Need more?{' '}
              <Link to="/enterprise">
                Bumpups Enterprise
              </Link>
            </p>
          </div>
        </section>

        <PricingTable />
        <FAQComponent />
        <Footer />
      </div>
    </AuthProvider>
  );
};

export default PricingPage;
